// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"omnijus-campo-numero-processo_input-wrapper__NVWJU","acao":"omnijus-campo-numero-processo_acao__1EoS9"};